import moment from 'moment';

export const nullifyPatient = (params) => {
	const patient = params.patient;
	if (patient.name && !patient.name.firstName) patient.name.firstName = null;
	if (patient.name && !patient.name.lastName) patient.name.lastName = null;
	if (!patient.email) patient.email = null;
	if (!patient.idCard) patient.idCard = null;
	if (!patient.dob) patient.dob = null;
	
	// Ensure mobile structure is maintained even if mobile number is empty
	if (patient.mobile) {
		if (!patient.mobile.mobileNumber) patient.mobile.mobileNumber = null;
		if (!patient.mobile.countryPrefixCode) patient.mobile.countryPrefixCode = 356; // Default to Malta
	} else {
		patient.mobile = { mobileNumber: null, countryPrefixCode: 356 };
	}
	
	// Handle landline similarly
	if (patient.landline) {
		if (!patient.landline.landlineNumber) patient.landline.landlineNumber = null;
		if (!patient.landline.countryPrefixCode) patient.landline.countryPrefixCode = 356;
	} else {
		patient.landline = { landlineNumber: null, countryPrefixCode: 356 };
	}

	return params;
}

export const sortBy = function (path, reverse, primer, then) {
	var get = function (obj, path) {
		if (path) {
			path = path.split('.');
			for (var i = 0, len = path.length - 1; i < len; i++) {
				obj = obj[path[i]];
			};
			return obj[path[len]];
		}
		return obj;
	},
		prime = function (obj) {
			return primer ? primer(get(obj, path)) : get(obj, path);
		};

	return function (a, b) {
		var A = prime(a),
			B = prime(b);

		return (
			(A < B) ? -1 :
				(A > B) ? 1 :
					(typeof then === 'function') ? then(a, b) : 0
		) * [1, -1][+!!reverse];
	};
};

export const clearStorage = () => {
	window.localStorage.removeItem('currentDoctorClinic');
	window.localStorage.removeItem('currentDoctorClinicFee');
	window.localStorage.removeItem('currentDoctorId');
	window.localStorage.removeItem('currentDoctorFields');
	window.localStorage.removeItem('currentDoctorFirstName');
	window.localStorage.removeItem('currentDoctorLastName');
	window.localStorage.removeItem('currentDoctorPayAt');
	window.localStorage.removeItem('currentDoctorRate');
	window.localStorage.removeItem('currentDoctorSchedule');
	window.localStorage.removeItem('currentDoctorServices');
	window.localStorage.removeItem('currentDoctorSpeciality');
	window.localStorage.removeItem('currentDoctorStep');
	window.localStorage.removeItem('currentDoctorTitle');
	window.localStorage.removeItem('firstLoad');
	window.localStorage.removeItem('userId');
	window.localStorage.removeItem('userRights');
}

export const formatRequest = (obj) => {
    // Helper function to check if a string looks like a UUID
    const isUUID = (str) => {
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return typeof str === 'string' && uuidPattern.test(str);
    };
    
    // Helper function to check if a string looks like an ISO date
    const isPotentialDate = (str) => {
        // Only attempt to parse as date if it has a format that looks like a date
        // This avoids the deprecation warning by not passing random strings to moment()
        return typeof str === 'string' && (
            /^\d{4}-\d{2}-\d{2}/.test(str) || // ISO date format
            /^\d{4}\/\d{2}\/\d{2}/.test(str) || // slash date format
            /^[a-zA-Z]{3}\s\d{2}\s\d{4}/.test(str) // month name format
        );
    };

    if (obj && obj instanceof Object) {
        for (let p in obj) {
            if (obj[p] && obj[p] instanceof Object) {
                obj[p] = formatRequest(obj[p]);
            } 
            else if (obj[p] && typeof obj[p] === 'string') {
                // Skip UUID formatting
                if (isUUID(obj[p])) {
                    continue;
                }
                
                // Only try moment validation for strings that look like dates
                if (!isPotentialDate(obj[p]) || !moment(obj[p], moment.ISO_8601, true).isValid()) {
                    obj[p] = obj[p].toLowerCase().trim();
                }
            }
        }
    } else if (typeof obj === 'string') {
        // Don't process UUIDs
        if (!isUUID(obj)) {
            // Only try moment validation for strings that look like dates
            if (!isPotentialDate(obj) || !moment(obj, moment.ISO_8601, true).isValid()) {
                obj = obj.toLowerCase().trim();
            }
        }
    }
    
    return obj;
}

export const camel = (str) => {
	let tempStr = '';
	if (str && typeof str === 'string' && str[0]) {
		tempStr = str[0].toUpperCase();
	} else return str;

	return tempStr + str.substring(1, str.length);
}

export const buildSearchableText = (patient) => {
	if (!patient) return '';
	
	const parts = [];
	
	// Add first name
	if (patient.name && patient.name.firstName) {
		parts.push(patient.name.firstName.toLowerCase().trim());
	}
	
	// Add last name
	if (patient.name && patient.name.lastName) {
		parts.push(patient.name.lastName.toLowerCase().trim());
	}
	
	// Add mobile number (digits only)
	if (patient.mobile && patient.mobile.mobileNumber) {
		const mobileDigits = patient.mobile.mobileNumber.replace(/\D/g, '');
		if (mobileDigits) {
			parts.push(mobileDigits);
		}
	}
	
	// Add email
	if (patient.email) {
		parts.push(patient.email.toLowerCase().trim());
	}
	
	// Add ID card
	if (patient.idCard) {
		parts.push(patient.idCard.toLowerCase().trim());
	}
	
	// Add landline number (digits only)
	if (patient.landline && patient.landline.landlineNumber) {
		const landlineDigits = patient.landline.landlineNumber.replace(/\D/g, '');
		if (landlineDigits) {
			parts.push(landlineDigits);
		}
	}
	
	return parts.filter(Boolean).join('|');
}